export const Skillset = {
  id: "skills",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Skills",
  headLine: "My Skillset",
  imgStart: false,
  img: "svg-3.svg",
  alt: "Man in front of whiteboard",
  // button properties
  // buttonLabel: "Check it out",
  // dark: true,
  // primary: true,
  // darkText: false,
};
